import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, FormsModule, ReactiveFormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NeoInputSearchModule } from '@neogov/pattern-library/neo-input-search';

@Component({
  selector: 'cm-search-field',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NeoInputSearchModule],
  templateUrl: './search-field.component.html',
  styleUrl: './search-field.component.less',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SearchFieldComponent,
      multi: true,
    },
  ],
})
export class SearchFieldComponent implements ControlValueAccessor {
  public readonly placeholder = input<string>('');
  public readonly autId = input.required<string>();
  public readonly label = input<string>('');
  public readonly ariaLabel = input<string>('');

  public value = '';
  public disabled = false;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onChange: (value: string) => void = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onTouched: () => void = () => {};

  public writeValue(value: string): void {
    this.value = value || '';
  }

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public onSearchChange(value: string): void {
    this.value = value;
    this.onChange(this.value);
    this.onTouched();
  }

  public onClearSearch(): void {
    this.value = '';
    this.onChange(this.value);
    this.onTouched();
  }
}
